/**
 * Generate Slide with Splide.js
 */
document.addEventListener("DOMContentLoaded", function () {
  const sliderElement = document.querySelector(".videos-product__slider");
  let splideInstance;

  function initSplide() {
    if (splideInstance) {
      splideInstance.destroy(true);
      splideInstance = null;
    }

    if (window.innerWidth < 768) {
      splideInstance = new Splide(sliderElement, {
        type: "slide",
        rewind: true,
        perPage: 1.98,
        focus: "center",
        pagination: false,
        arrows: false,
        gap: "14px",
        start: 1,
      }).mount();
    }
  }

  initSplide();
  window.addEventListener("resize", initSplide);
});

/**
 * Handles the video popup functionality and its interactions
 */

// Global state for the modal
const modalState = {
  activeCheckboxId: null
};

/**
 * Creates a clone of the video with the necessary settings
 * @param {HTMLVideoElement} videoElement - Original video element
 * @returns {HTMLVideoElement} Configured video clone
 */
function createVideoClone(videoElement) {
  const videoClone = videoElement.cloneNode(true);
  videoClone.setAttribute('controls', 'true');
  videoClone.muted = false;
  videoClone.volume = 1.0;
  return videoClone;
}

/**
 * Closes the modal and clears its content
 * @param {HTMLElement} modal - Modal element
 * @param {HTMLElement} videoContainer - Video container
 */
function closeModal(modal, videoContainer) {
  modal.classList.add('hidden');
  videoContainer.innerHTML = '';
  modalState.activeCheckboxId = null;
}

/**
 * Opens the modal and configures the video
 * @param {HTMLElement} modal - Modal element
 * @param {HTMLElement} videoContainer - Video container
 * @param {string} checkboxId - ID of the selected checkbox
 * @param {HTMLVideoElement} videoElement - Video element to display
 */
function openModal(modal, videoContainer, checkboxId, videoElement) {
  // Update state
  modalState.activeCheckboxId = checkboxId;
  modal.classList.remove('hidden');

  // Update labels inside the modal
  modal.querySelectorAll('label').forEach(label => {
    label.setAttribute('for', checkboxId);
  });

  // Configure and display the video
  const videoClone = createVideoClone(videoElement);
  videoContainer.innerHTML = '';
  videoContainer.appendChild(videoClone);
}

/**
 * Handles the state change of a checkbox
 * @param {HTMLElement} modal - Modal element
 * @param {HTMLElement} videoContainer - Video container
 * @param {HTMLInputElement} checkbox - Checkbox that triggered the event
 */
function handleCheckboxChange(modal, videoContainer, checkbox) {
  const videoElement = checkbox.closest('.videos-product__item')?.querySelector('video');
  const checkboxId = checkbox.id;

  if (!videoElement) {
    console.warn('Video element not found');
    return;
  }

  // If the same checkbox is active, close the modal
  if (!modal.classList.contains('hidden') && modalState.activeCheckboxId === checkboxId) {
    closeModal(modal, videoContainer);
    return;
  }

  openModal(modal, videoContainer, checkboxId, videoElement);
}

/**
 * Initializes event listeners for the checkboxes
 */
function initVideoModal() {
  const modal = document.querySelector('.videos-product-modal');
  const videoContainer = modal?.querySelector('.videos-product-modal__video');
  const checkboxes = document.querySelectorAll('.videos-product__checkbox');

  if (!modal || !videoContainer) {
    console.error('Required modal elements not found');
    return;
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => 
      handleCheckboxChange(modal, videoContainer, checkbox)
    );
  });
}
document.addEventListener('DOMContentLoaded', initVideoModal);
